import { ExclamationCircleIcon } from "@heroicons/react/outline";
import ConfirmModal from "../../../components/ConfirmModal";

type CheckoutConfirmationWarningProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  description: string;
};

export default function CheckoutConfirmationWarning({
  isOpen,
  onClose,
  onConfirm,
  description,
}: CheckoutConfirmationWarningProps) {
  return (
    <ConfirmModal
      open={isOpen}
      onClose={onClose}
      icon={
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-warning-subtler">
          <ExclamationCircleIcon
            className="h-6 w-6 text-warning"
            aria-hidden="true"
          />
        </div>
      }
      title="Warning Checkout settings"
      confirmBtnText="Save anyway"
      desc={description}
      onConfirm={onConfirm}
    />
  );
}
